module.exports = __webpack_public_path__ + "img/cn.29d9cf35.svg";